export default __webpack_public_path__ + "images/Collection 1-b8f80e9f63.svg";